import { Injectable } from '@angular/core';
import { IOtherSettings, IOtherSettingsSmtpServer } from './other-settings';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { UserModel } from '@fi-app/user/user.model';
import { IFiCustomerSupportContact } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Injectable()
export class OtherSettingsService {
    constructor(private fiBackend: FiBackendService) {}

    getOtherSettings() {
        return this.fiBackend.fetchData<IOtherSettings[]>('Core/OtherSettings/GetOtherSettings');
    }

    getSupportContact() {
        return this.fiBackend.fetchData<IFiCustomerSupportContact>('Core/OtherSettings/GetSupportContact');
    }
    saveSupportContact(supportContact: IFiCustomerSupportContact) {
        return this.fiBackend.fetchDataPost('Core/OtherSettings/SaveSupportContact', supportContact);
    }

    getSmtpServer() {
        return this.fiBackend.fetchData<IOtherSettingsSmtpServer>('Core/OtherSettings/GetSmtpServer');
    }
    saveSmtpServer(smtpServer: IOtherSettingsSmtpServer) {
        return this.fiBackend.fetchDataPost('Core/OtherSettings/SaveSmtpServer', smtpServer);
    }

    testSmtpServer(smtpServer: IOtherSettingsSmtpServer, testEmailRecipient: string) {
        return this.fiBackend.fetchDataPost<{ result: boolean; errorMessage: string }>(
            `Core/OtherSettings/TestSmtpServer?testEmailRecipient=${testEmailRecipient}`,
            smtpServer,
        );
    }

    getSupportManagers() {
        return this.fiBackend.fetchData<UserModel[]>('Core/OtherSettings/GetSupportManagers');
    }
}
